<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre1" id="pgepubid00000">THE SKY PILOT</h1>
<h1 class="calibre1 sigil_not_in_toc">IN NO MAN'S LAND</h1>
<h2 class="sigil_not_in_toc" id="calibre_pb_0">By Ralph Connor</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?f29bf106